import Sidebar, { SidebarItem } from '.';

interface SidebarValidityProps {
  children: any;
}

export function SidebarValidity({ children }: SidebarValidityProps) {
  const items: SidebarItem[] = [
    {
      name: 'Dashboard',
      path: '/tools/validity',
    },
    {
      name: 'Validades',
      path: '/tools/validity/validities',
    },
    {
      name: 'Status',
      path: '/tools/validity/status',
    },
  ];

  return <Sidebar items={items} children={children} />;
}
